/**
 * Aggregate materials_used across all units into a single summary list.
 * Combines same-named materials (case-insensitive) and sums their quantities.
 * Units (kpl, m, l) are kept as the first seen per name.
 *
 * @param {Array<{materials_used?: Array<{name, qty, unit}>}>} units
 * @returns {Array<{name, qty, unit}>}
 */
export function aggregateMaterialsUsed(units) {
  const map = new Map();
  (units || []).forEach((u) => {
    (u?.materials_used || []).forEach((m) => {
      const name = (m?.name || "").trim();
      if (!name) return;
      const key = name.toLowerCase();
      const qty = Number(m?.qty) || 0;
      const unit = (m?.unit || "kpl").trim() || "kpl";
      if (map.has(key)) {
        const e = map.get(key);
        e.qty += qty;
      } else {
        map.set(key, { name, qty, unit });
      }
    });
  });
  return Array.from(map.values()).sort((a, b) => a.name.localeCompare(b.name, "fi"));
}

/** Format a numeric quantity: strip trailing .0 when integer. */
export function formatQty(q) {
  if (q == null) return "";
  const n = Number(q);
  if (Number.isNaN(n)) return String(q);
  if (Number.isInteger(n)) return String(n);
  // Keep 1 decimal
  return n.toFixed(1).replace(/\.0$/, "");
}
